export class LoginAction {
  public action: string;
  public args: string[];
  public payload: object;
  public result: { [key: string]: LoginAction };

  constructor(action: string, args: string[], result: { [key: string]: LoginAction } = {}, payload: object = {}) {
    this.action = action;
    this.args = args;
    this.result = result;
    this.payload = payload;
  }
}
